/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_AffiliateInputs */

const en_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate Program`)
};

const es_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa de afiliados`)
};

const fr_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme d'affiliation`)
};

const de_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate-Programm`)
};

const ja_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフィリエイトプログラム`)
};

const zh_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广计划`)
};

const ar_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برنامج التسويق بالعمولة`)
};

const id_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program Afiliasi`)
};

const it_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma Affiliati`)
};

const ru_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Партнерская программа`)
};

const pt_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa de Afiliados`)
};

const ko_footer_link_affiliate = /** @type {(inputs: Footer_Link_AffiliateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어필리에이트 프로그램`)
};

/**
* | output |
* | --- |
* | "Affiliate Program" |
*
* @param {Footer_Link_AffiliateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_affiliate = /** @type {((inputs?: Footer_Link_AffiliateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_AffiliateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_affiliate(inputs)
	if (locale === "es") return es_footer_link_affiliate(inputs)
	if (locale === "fr") return fr_footer_link_affiliate(inputs)
	if (locale === "de") return de_footer_link_affiliate(inputs)
	if (locale === "ja") return ja_footer_link_affiliate(inputs)
	if (locale === "zh") return zh_footer_link_affiliate(inputs)
	if (locale === "ar") return ar_footer_link_affiliate(inputs)
	if (locale === "id") return id_footer_link_affiliate(inputs)
	if (locale === "it") return it_footer_link_affiliate(inputs)
	if (locale === "ru") return ru_footer_link_affiliate(inputs)
	if (locale === "pt") return pt_footer_link_affiliate(inputs)
	return ko_footer_link_affiliate(inputs)
});